import style from "./style.module.scss";
import { useContext } from "react";
import { messageContext } from "commons/contexts";

export default function MessageBox() {
    const { message, setMessage } = useContext(messageContext);

    return message && <div className={style.root}>
        <div className={style.container}>
            <div className={style.close}><div onClick={() => setMessage(null)}>X</div></div>
            <div className={style.box}>
                <div className={style.title} >{message.title}</div>
                <div className={style.text} >{message.text}</div>
                <div className={style.buttonCnt}>
                    {
                        message?.buttons?.map((button: Record<string, any>) => {
                            return <input className={style.button} value={button.name} type="button" onClick={button?.action} />
                        })
                    }
                </div>
            </div>
        </div>
    </div>;
}